import { BrowserModule , Title  } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { RouterModule } from '@angular/router';
import { PricingComponent } from './pricing/pricing.component';
import { RefundComponent } from './refund/refund.component';
import { FederalComponent } from './services/federal/federal.component';
import { TaxComponent } from './services/tax/tax.component';
import { FbarComponent } from './services/fbar/fbar.component';
import { EvaluationComponent } from './services/evaluation/evaluation.component';
import { FilingComponent } from './services/filing/filing.component';
import { AmendmentComponent } from './services/amendment/amendment.component';
import { AdvancedComponent } from './services/advanced/advanced.component';
import { LoginComponent } from './login/login.component';


// import { HttpModule } from '@angular/http';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RegisterComponent } from './register/register.component';
import { WebsiteHeaderComponent } from './website-header/website-header.component';
import { WebsiteFooterComponent } from './website-footer/website-footer.component';
import { UserHeaderComponent } from './user/user-header/user-header.component';
import { UserFooterComponent } from './user/user-footer/user-footer.component';
import { UserModule } from './user/user.module';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ToastrModule } from 'ngx-toastr';
import { DashboardComponent } from './user/dashboard/dashboard.component';
import { BasicComponent } from './user/basic/basic.component';
import { DocumentsComponent } from './user/documents/documents.component';
import { UploadDocumentComponent } from './user/upload-document/upload-document.component';
import { DownloadTaxReturnComponent } from './user/download-tax-return/download-tax-return.component';
import { MakePaymentComponent } from './user/make-payment/make-payment.component';
import { ContentDisclosureComponent } from './user/content-disclosure/content-disclosure.component';
import { ReferFriendComponent } from './refer-friend/refer-friend.component';
import { ForgotComponent } from './forgot/forgot.component';
import { ForgotEmailComponent } from './forgot-email/forgot-email.component';
import { ReferDashboardComponent } from './user/refer-dashboard/refer-dashboard.component';
import { ChangepwdComponent } from './user/changepwd/changepwd.component';

import { CountdownModule } from 'ngx-countdown';
import { VerifyComponent } from './verify/verify.component';
import { AlreadyVerifiedComponent } from './already-verified/already-verified.component';
import { LoginAdminComponent } from './admin/login-admin/login-admin.component';
import { AdminModule } from './admin/admin.module';
import { DashboardAdminComponent } from './admin/dashboard-admin/dashboard-admin.component';
import { DashboardmainAdminComponent } from './admin/dashboardmain-admin/dashboardmain-admin.component';
import { AddZoneAdminComponent } from './admin/Manage-Zone-Admins/add-zone-admin/add-zone-admin.component';
import { ChangePwdAdminComponent } from './admin/change-pwd-admin/change-pwd-admin.component';

import { ChartsModule } from 'ng2-charts';
import { AllClientsComponent } from './admin/Manage-Clients/all-clients/all-clients.component';
import { ClientsDocumentsComponent } from './admin/Manage-Clients/clients-documents/clients-documents.component';
import { ManageCategoryAdminComponent } from './admin/Settings/manage-category-admin/manage-category-admin.component';
import { ViewContactUsAdminComponent } from './admin/Settings/view-contact-us-admin/view-contact-us-admin.component';
import { ViewReferralHistoryAdminComponent } from './admin/Settings/view-referral-history-admin/view-referral-history-admin.component';
import { ViewFileDownloadHistoryAdminComponent } from './admin/Settings/view-file-download-history-admin/view-file-download-history-admin.component';

import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxPaginationModule } from 'ngx-pagination';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { NgxSpinnerModule } from "ngx-spinner";  

import { ShowHidePasswordModule } from 'ngx-show-hide-password';
import { WhatAreWeComponent } from './About-US/what-are-we/what-are-we.component';
import { VisionMissionComponent } from './About-US/vision-mission/vision-mission.component';
import { StrategicChangesComponent } from './About-US/strategic-changes/strategic-changes.component';
import { LeadsHistoryAdminComponent } from './admin/Settings/leads-history-admin/leads-history-admin.component';
import { LeadBulkUploadsAdminComponent } from './admin/Manage-Leads/lead-bulk-uploads-admin/lead-bulk-uploads-admin.component';
import { AddLeadsAdminComponent } from './admin/Manage-Leads/add-leads-admin/add-leads-admin.component';
import { ManageLeadsAdminComponent } from './admin/Manage-Leads/manage-leads-admin/manage-leads-admin.component';
import { ManageZoneAdminComponent } from './admin/Manage-Zone-Admins/manage-zone-admin/manage-zone-admin.component';
import { ManageReturnTaxComponent } from './admin/return-tax/manage-return-tax/manage-return-tax.component';
import { UploadReturnTaxAdminComponent } from './admin/return-tax/upload-return-tax-admin/upload-return-tax-admin.component';
import { DxButtonModule } from 'devextreme-angular';
import { NgOtpInputModule } from  'ng-otp-input';
import { WhislistsAdminComponent } from './admin/whislists-admin/whislists-admin.component';
import { SessionService } from './session.service';
import { SessionAdminService } from './admin/session-admin.service';
import { RestService } from './admin/rest.service';
import { ItinComponent } from './services/itin/itin.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    PricingComponent,
    RefundComponent,
    FederalComponent,
    TaxComponent,
    FbarComponent,
    EvaluationComponent,
    FilingComponent,
    AmendmentComponent,
    AdvancedComponent,
    LoginComponent,
    RegisterComponent,
    WebsiteHeaderComponent,
    WebsiteFooterComponent,
    ReferFriendComponent,
    ForgotComponent,
    ForgotEmailComponent,
    VerifyComponent,
    AlreadyVerifiedComponent,
    WhatAreWeComponent,
    VisionMissionComponent,
    StrategicChangesComponent,
    ItinComponent,
  ],
  imports: [
    DxButtonModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule ,
    UserModule,
    AdminModule,
    BrowserAnimationsModule,
    ChartsModule,
    NgxDatatableModule,
    NgxPaginationModule,    
    Ng2SearchPipeModule,
    ToastrModule.forRoot(),
    CountdownModule,
    ShowHidePasswordModule,
    NgxSpinnerModule,
    NgOtpInputModule,
    RouterModule.forRoot([
      {path:'',component:HomeComponent},
      { path: 'home', component: HomeComponent },
      { path: 'what-are-we', component: WhatAreWeComponent },
      { path: 'vision-mission', component: VisionMissionComponent },
      { path: 'strategic-changes', component: StrategicChangesComponent },
      { path: 'pricing', component: PricingComponent },
      {path:'refund', component:RefundComponent},
      {path:'federal', component:FederalComponent},
      {path:'itIn', component:ItinComponent},
      {path:'tax', component:TaxComponent},
      {path:'fbar', component:FbarComponent},
      {path:'evaluation', component:EvaluationComponent},
      {path:'filing', component:FilingComponent},
      {path:'amendment', component:AmendmentComponent},
      {path:'advanced', component:AdvancedComponent},
      {path:'login', component:LoginComponent},   
      {path:'register', component:RegisterComponent},  
      {path:'header', canActivate: [SessionService], component:UserHeaderComponent}, 


      {path:'dashboard', canActivate: [SessionService],component:DashboardComponent },
      {path:'basic', canActivate: [SessionService], component:BasicComponent },
      {path:'documents', canActivate: [SessionService], component:DocumentsComponent},
      {path:'upload', canActivate: [SessionService], component:UploadDocumentComponent},
      {path:'download', canActivate: [SessionService],component:DownloadTaxReturnComponent},
      {path:'payment', canActivate: [SessionService], component:MakePaymentComponent},
      {path:'disclosure', canActivate: [SessionService], component:ContentDisclosureComponent},
      {path:'refer', canActivate: [SessionService], component:ReferFriendComponent},
      {path:'forgot', component:ForgotComponent},
      {path:'forgot_email', component:ForgotEmailComponent},
      {path:'refer-friend', canActivate: [SessionService], component:ReferDashboardComponent},
      {path:'changePassword', canActivate: [SessionService], component:ChangepwdComponent},
      {path:'verify', component:VerifyComponent},
      {path:'already', component:AlreadyVerifiedComponent},

      // @@@@@@@@@@@@@@@@@@@@@@

      {path:'login-admin', component:LoginAdminComponent},
      {path:'dashboard-admin',  canActivate: [SessionAdminService], component:DashboardAdminComponent},
      {path:'dashboardmain-admin', canActivate: [SessionAdminService], component:DashboardmainAdminComponent},
      {path:'zoneadmin-admin', canActivate: [SessionAdminService], component:AddZoneAdminComponent},
      {path:'changepwd-admin', canActivate: [SessionAdminService], component:ChangePwdAdminComponent},
      {path:'all-clients', canActivate: [SessionAdminService], component:AllClientsComponent},
      {path:'clients-documents', canActivate: [SessionAdminService], component:ClientsDocumentsComponent},
      {path:'manage-category-admin', canActivate: [SessionAdminService], component:ManageCategoryAdminComponent},
      {path:'view-contactus-admin', canActivate: [SessionAdminService], component:ViewContactUsAdminComponent},
      {path:'view-referral-admin', canActivate: [SessionAdminService], component:ViewReferralHistoryAdminComponent},
      {path:'view-fileDownload-admin', canActivate: [SessionAdminService], component:ViewFileDownloadHistoryAdminComponent},
      {path:'viewLeadHistory', canActivate: [SessionAdminService], component:LeadsHistoryAdminComponent},

      {path:'bulkUploads', canActivate: [SessionAdminService], component:LeadBulkUploadsAdminComponent},
      {path:'addLeads', canActivate: [SessionAdminService], component:AddLeadsAdminComponent},
      {path:'manageLeads', canActivate: [SessionAdminService], component:ManageLeadsAdminComponent},
      {path:'manage-zone-admin', canActivate: [SessionAdminService], component: ManageZoneAdminComponent},
      {path:'manage-return-tax', canActivate: [SessionAdminService], component: ManageReturnTaxComponent},
      {path:'upload-return-tax-admin', canActivate: [SessionAdminService], component: UploadReturnTaxAdminComponent},
      {path:'wishlist', canActivate: [SessionAdminService], component: WhislistsAdminComponent},
      
    ])
  ],
  exports: [
    WebsiteHeaderComponent,WebsiteFooterComponent
  ],
  providers: [HttpClientModule,SessionService,SessionAdminService,Title,
    { provide: HTTP_INTERCEPTORS, useClass: RestService, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
